module.exports = __webpack_public_path__ + "static/media/type_a_id.58889af7.png";